<template>
    <section class="events-list-selection">
        <div class="content">
            <PrismicRichText :field="slice.primary.title" class="title" />
            <Swiper
                slides-per-view="auto"
                :breakpoints="{[breakpoints.mobile]: {spaceBetween: 40}}"
                :space-between="24"
                :modules="MODULES"
                :navigation="true"
            >
                <SwiperSlide
                    v-for="(item, index) in slice.items.filter((item) => isFilled.contentRelationship(item.event))"
                    :key="`event-${index}`"
                    class="slide"
                >
                    <EventCard :event="item.event as FilledContentRelationshipField<'event', string, EventDocumentData>" />
                </SwiperSlide>
            </Swiper>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import type {FilledContentRelationshipField} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';
    import type {EventDocumentData, EventsListSliceSelection} from '@prismicio-types';
    // @ts-expect-error - swiper has no types
    import {Navigation} from 'swiper';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import {useRuntimeConfig} from '#imports';
    import 'swiper/css';
    import 'swiper/css/navigation';
    import EventCard from '~/components/EventCard.vue';
    const MODULES = [Navigation];

    defineProps<{slice: EventsListSliceSelection}>();
    const {breakpoints} = useRuntimeConfig().public;
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;
    .events-list-selection {
        overflow: hidden;
        position: relative;

        .resource-card {
            padding: 0;
            border: none;

            &:hover {
                box-shadow: none;
            }
        }

        .content {
            @include content-width;
        }
        .title h2 {
            margin-bottom: var(--joy-core-spacing-9);
        }
        .swiper {
            overflow: visible;
            margin-right: 40px;
            padding-bottom: 80px;
            @media (max-width: $mobile-breakpoint) {
                margin-right: 0;
            }
        }
        .swiper-wrapper {
            overflow: visible;
        }
        .slide {
            width: auto;
            max-width: 400px;

            @media (max-width: $mobile-breakpoint) {
                width: 250px;
            }
        }
        .swiper-button-prev,
        .swiper-button-next {
            content: url('~/assets/svg/arrowRight.svg');
            padding: var(--joy-core-spacing-3);
            border-radius: var(--joy-core-radius-6);
            height: 42px;
            width: 42px;
            background-color: var(--joy-color-primary-50);
            position: absolute;
            top: unset;
            bottom: 10px;
            left: unset;
            right: 0;
        }
        .swiper-button-prev {
            transform: rotate(180deg);
            left: unset;
            right: 60px;
        }
    }
</style>
